var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0 ma-0", attrs: { fluid: "" } },
    [
      _c("v-file-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        attrs: {
          id: "fileInput",
          "hide-input": "",
          multiple: "",
          accept: "doc,docx,pdf,ppt,jpg,jpeg,png,xlsx,xls",
        },
        on: { change: _vm.chooseUploadFile },
      }),
      _c(
        "v-row",
        { attrs: { dense: "", align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { xs: "12", sm: "12", md: "12", lg: "12", cols: "12" } },
            [
              _c(
                "v-sheet",
                { staticClass: "text--secondary d-inline-block text-truncate" },
                [
                  _vm.showLabel
                    ? _c("span", { class: _vm.labelClass }, [
                        _vm._v(_vm._s(_vm.label)),
                      ])
                    : _vm._e(),
                ]
              ),
              !_vm.disabled
                ? _c(
                    "v-card",
                    {
                      staticClass: "rounded-lg",
                      style: {
                        border:
                          "2px dashed " +
                          (_vm.isRequire &&
                          _vm.isActive &&
                          _vm.fileList.length == 0
                            ? "red"
                            : "var(--main-border-color)"),
                      },
                      attrs: { elevation: "0" },
                      on: { dragover: _vm.fileDragover, drop: _vm.fileDrop },
                    },
                    [
                      _c(
                        "v-sheet",
                        { staticClass: "text-center align-center mrc-grey" },
                        [
                          _c("div", [
                            _c(
                              "i",
                              {
                                staticClass:
                                  "material-icons-round md-72 text--secondary lighten-2",
                              },
                              [_vm._v("backup")]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "py-3" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_update_components_tipLabel"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "text-capitalize ml-2",
                                  attrs: {
                                    color: "primary lighten-2 ",
                                    small: "",
                                    rounded: "",
                                    disabled:
                                      _vm.disabled ||
                                      (_vm.isSingle &&
                                        _vm.fileUuids.length > 0),
                                  },
                                  on: { click: _vm.toChoose },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_update_components_browseBtnLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.isRequire && _vm.isActive && _vm.fileList.length == 0
            ? _c("v-sheet", { staticClass: "red--text px-1" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("verify_essweb_form_textField_dataCommonLabel") +
                      _vm.$t("verify_essweb_form_textField_textisNullTextLabel")
                  )
                ),
              ])
            : _vm._e(),
          _vm.fileList.length
            ? _c(
                "v-col",
                {
                  attrs: { xs: "12", sm: "12", md: "12", lg: "12", cols: "12" },
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "scroll_content_y pa-0 ma-0",
                      style: { maxHeight: "214px" },
                    },
                    _vm._l(_vm.fileList, function (item, index) {
                      return _c(
                        "v-sheet",
                        {
                          key: "file--" + index + "---" + item.id,
                          staticClass: "rounded-lg my-2 mrc-border-solid",
                          staticStyle: { position: "relative" },
                        },
                        [
                          item.uploading
                            ? _c("v-progress-linear", {
                                staticClass: "rounded-lg",
                                style: { top: 0, zIndex: 0 },
                                attrs: {
                                  absolute: "",
                                  height: "100%",
                                  "background-opacity": "0",
                                  "buffer-value": 100,
                                  color: "primary lighten-3",
                                },
                                model: {
                                  value: item.progress,
                                  callback: function ($$v) {
                                    _vm.$set(item, "progress", $$v)
                                  },
                                  expression: "item.progress",
                                },
                              })
                            : _vm._e(),
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "text-left align-center d-flex transparent px-2 py-2",
                              style: { zIndex: 1, position: "relative" },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  size: "32",
                                  fill: item.updated ? "#0f46c1" : "grey",
                                  iconClass:
                                    item.file_type == "jpg"
                                      ? "filetype-jpg"
                                      : item.file_type == "csv"
                                      ? "filetype-csv"
                                      : item.file_type == "doc"
                                      ? "filetype-doc"
                                      : item.file_type == "gif"
                                      ? "filetype-gif"
                                      : item.file_type == "png"
                                      ? "filetype-png"
                                      : item.file_type == "xls"
                                      ? "filetype-xls"
                                      : item.file_type == "docx"
                                      ? "filetype-doc"
                                      : item.file_type == "xlsx"
                                      ? "filetype-xls"
                                      : item.file_type == "pdf"
                                      ? "filetype-pdf"
                                      : item.file_type == "ppt"
                                      ? "filetype-ppt"
                                      : item.file_type == "jpeg"
                                      ? "filetype-jpg"
                                      : "filetype-file",
                                },
                              }),
                              _c(
                                "v-sheet",
                                {
                                  staticClass:
                                    "\n                text-subtitle-2\n                px-1\n                transparent\n                text-left\n                align-center\n                d-flex\n              ",
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "text-subtitle-2 transparent text-truncate",
                                      class: item.updated_fail
                                        ? "red--text"
                                        : "text--primary",
                                      style: { maxWidth: "90%" },
                                      attrs: { title: item.filename },
                                    },
                                    [_vm._v(" " + _vm._s(item.filename) + " ")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text--secondary text-caption px-1",
                                    },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.$byteconvert(item.size)) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("v-spacer"),
                              !_vm.disabled
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { small: "", icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteItem(item.id, item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("delete")]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "v-btn",
                                    {
                                      attrs: { small: "", icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toUrl(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("visibility")]
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }